import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import Organizations from 'src/pages/teams/Organizations';
import { useTheme } from '@mui/material/styles';

const NoActiveOrganization = observer(() => {
  const theme = useTheme();

  return (
    <Box
      className="hanabi-scrollbar"
      sx={{
        px: { xs: 2, md: 3 },
        py: { xs: 2, md: 3 },
        bgcolor: 'background.default',
        color: 'text.primary',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(4),
      }}
    >
      <Box
        sx={{
          width: '100%',
          px: { xs: 2.5, md: 4 },
          py: { xs: 3, md: 4 },
          borderRadius: 3,
          border: `1px solid ${theme.palette.divider}`,
          background: `linear-gradient(135deg, ${theme.palette.background.paper} 0%, rgba(25, 118, 210, 0.08) 100%)`,
          boxShadow: '0 18px 50px rgba(0, 0, 0, 0.22)',
        }}
      >
        <Typography
          variant="overline"
          sx={{
            display: 'block',
            mb: 1.5,
            color: 'primary.main',
            fontWeight: 700,
            letterSpacing: '0.14em',
          }}
        >
          ORGANIZATION ACCESS
        </Typography>
        <Typography
          variant="h3"
          sx={{
            mb: 2,
            fontSize: { xs: '2rem', md: '3rem' },
            fontWeight: 700,
            lineHeight: 1.1,
            maxWidth: 920,
          }}
        >
          Choose an organization to continue
        </Typography>
        <Typography
          variant="h6"
          color="text.secondary"
          sx={{
            mb: 3,
            fontSize: { xs: '1rem', md: '1.15rem' },
            lineHeight: 1.75,
            maxWidth: 1100,
            fontWeight: 400,
          }}
        >
          There is no active organization selected for your account right now.
          This page helps you reconnect your workspace so Hana knows which
          organization context, settings, and data to use in the dashboard.
        </Typography>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(3, minmax(0, 1fr))' },
            gap: 2,
          }}
        >
          <Box
            sx={{
              p: 2,
              borderRadius: 2,
              border: `1px solid ${theme.palette.divider}`,
              backgroundColor: 'rgba(255, 255, 255, 0.02)',
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
              Select an existing org
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Use one of the organizations listed below and mark it active to
              resume work immediately.
            </Typography>
          </Box>
          <Box
            sx={{
              p: 2,
              borderRadius: 2,
              border: `1px solid ${theme.palette.divider}`,
              backgroundColor: 'rgba(255, 255, 255, 0.02)',
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
              Join with an invite
            </Typography>
            <Typography variant="body2" color="text.secondary">
              If another team invited you, use the join option to connect that
              organization to your account.
            </Typography>
          </Box>
          <Box
            sx={{
              p: 2,
              borderRadius: 2,
              border: `1px solid ${theme.palette.divider}`,
              backgroundColor: 'rgba(255, 255, 255, 0.02)',
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
              Create a new org
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Start a new organization if you need a separate workspace for a
              new team, client, or business unit.
            </Typography>
          </Box>
        </Box>
      </Box>
      <Organizations />
    </Box>
  );
});

export default NoActiveOrganization;
